import { ActivityStatus, PrestazioneConfigDTO, PrestazioneDTO, SubTaskDTO, UserRole } from '../common/Dtos';
import React, { useContext, useEffect, useState } from 'react';
import { HeadCell, STableCell, STableHeader, STableRow } from '../common/ScrivaniaTable';
import { Box, Collapse, Divider, FormControl, Grid, IconButton, List, ListItem, MenuItem, Select, Table, TableBody, TableRow, TextField, Tooltip } from '@material-ui/core';
import { FaPauseCircle, FaPlayCircle, FaUserEdit, IoIosArrowDropdown, IoIosArrowDropup } from 'react-icons/all';
import TableCell from '@material-ui/core/TableCell';
import { SButton, SDialogButton, SExtraBackOfficeLabel, SInputLabel, SSubtitle } from '../common/BCommonComponents';
import AuthContext from '../auth/AuthContext';
import { SubTaskRow } from './ContattoSubTask';
import { dateTableFormat } from '../common/DateUtils';
import { toast } from 'react-toastify';
import { useNewStopwatch } from '../customHooks/NewTimerHook';

interface RowProps {
	row: PrestazioneDTO;
	labelid: string;
	onEsitoOk: (prestazione: PrestazioneDTO) => void;
	isBackoffice: boolean;
	onStartTimer: (prestazione: PrestazioneDTO) => void;
	onStopTimer: (prestazione: PrestazioneDTO) => void;
	disabled: boolean;
	disabledTimer: boolean;
	onModificaOperatore?: (prestazione: PrestazioneDTO) => void;
	idContatto?: string;
	backofficeOpzionali?: PrestazioneConfigDTO[];
}

export function PrestazioneContattoRow(props: RowProps) {
	const auth = useContext(AuthContext);
	const {row, labelid, onEsitoOk, isBackoffice, onStartTimer, onStopTimer, disabled, disabledTimer, onModificaOperatore, idContatto, backofficeOpzionali} = props;
	const [subTask, setSubTask] = useState(row.subTask ? row.subTask : []);
	const [open, setOpen] = React.useState(false);
	const [note, setNote] = React.useState(row.note);
	const [noteStatus, setNoteStatus] = React.useState(row.notaStatus ? row.notaStatus : 'Nulla da segnalare');
	const [selected, setSelected] = useState<string[]>(
		row.subTask ? row.subTask.map((subTaskRow) => {
			return subTaskRow.id;
		}) : []
	);
	const [backOfficeSelected, setBackOfficeSelected] = useState<string[]>([]);

	//TIMER
	const [terminated, setTerminated] = useState<boolean>(row.status !== ActivityStatus.WAIT);

	// const {
	// 	isRunning,
	// 	elapsedTime,
	// 	startTimer,
	// 	stopTimer,
	// } = useStopwatch(row.duration ? row.duration : 0);

	const {
		isRunning,
		elapsedTime,
		startTimer,
		stopTimer,
	} = useNewStopwatch(row.duration ? row.duration : 0);


	useEffect(() => {
	}, [subTask, note, terminated, noteStatus, auth, backOfficeSelected]);

	useEffect(() => {
		if (!terminated && !isBackoffice) {
			setOpen(true);
			startTimer();
		}
	}, []);

	const handleStartStop = () => {
		if (isRunning) {
			stopTimer();
			const a = elapsedTime.split(':');

			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			let subTaskList = [...subTask];
			subTaskList.forEach(s => {
				s.status = selected.find(st => st === s.id) ? ActivityStatus.OK : ActivityStatus.KO;
			});

			const newPrestazione: PrestazioneDTO = {
				id: props.row.id,
				name: props.row.name,
				operatore: props.row.operatore,
				codice: props.row.codice,
				cooperativa: props.row.cooperativa,
				origin: props.row.origin,
				type: props.row.type,
				startDate: props.row.startDate,
				endDate: props.row.endDate,
				status: ActivityStatus.WAIT,
				accesso: props.row.accesso,
				subTask: subTaskList,
				note: note,
				createdBy: props.row.createdBy,
				createdDate: props.row.createdDate,
				lastModifiedBy: props.row.lastModifiedBy,
				lastModifiedDate: props.row.lastModifiedDate,
				description: props.row.description,
				duration: seconds,
				idContatto: props.row.idContatto,
				notaStatus: noteStatus,
				boOpzionali: props.row.boOpzionali,
				boObbligatori: props.row.boObbligatori,
				tipoFrontOffice: props.row.tipoFrontOffice,
				puntoServizioId: props.row.puntoServizioId,
				puntoServizioName: props.row.puntoServizioName
			}
			onStopTimer(newPrestazione);
		} else {
			startTimer();
			onStartTimer(row);
			setOpen(true);
		}
	};

	const noteId = "noteRow-" + row.id;

	const rowHeadCells: HeadCell[] = [
		{id: 'descrizione', numeric: false, disablePadding: false, label: 'DESCRIZIONE', sortable: false},
		{id: 'statoAttivita', numeric: false, disablePadding: false, label: 'STATO ATTIVITA', sortable: false},
		{id: 'note', numeric: false, disablePadding: false, label: 'NOTE', sortable: false}
	];

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = row.subTask ? row.subTask.map((n) => n.id) : [];
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleEsitoOkClick = () => {
		stopTimer();
		setTerminated(true);
		const a = elapsedTime.split(':');

		const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
		let subTaskList = [...subTask];
		subTaskList.forEach(s => {
			s.status = selected.find(st => st === s.id) ? ActivityStatus.OK : ActivityStatus.KO;
		});

		const newPrestazione: PrestazioneDTO = {
			id: props.row.id,
			name: props.row.name,
			operatore: props.row.operatore,
			codice: props.row.codice,
			cooperativa: props.row.cooperativa,
			origin: props.row.origin,
			type: props.row.type,
			startDate: props.row.startDate,
			endDate: props.row.endDate,
			status: ActivityStatus.OK,
			accesso: props.row.accesso,
			subTask: subTaskList,
			note: note,
			createdBy: props.row.createdBy,
			createdDate: props.row.createdDate,
			lastModifiedBy: props.row.lastModifiedBy,
			lastModifiedDate: props.row.lastModifiedDate,
			description: props.row.description,
			duration: seconds,
			idContatto: props.row.idContatto,
			notaStatus: noteStatus,
			boOpzionali: props.row.boOpzionali,
			boObbligatori: props.row.boObbligatori,
			tipoFrontOffice: props.row.tipoFrontOffice,
			puntoServizioId: props.row.puntoServizioId,
			puntoServizioName: props.row.puntoServizioName,
			paziente: props.row.paziente
		}
		onEsitoOk(newPrestazione);
	}

	const handleEsitoKoClick = () => {
		stopTimer();
		setTerminated(true);
		const a = elapsedTime.split(':');

		const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
		let subTaskList = [...subTask];
		subTaskList.forEach(s => {
			// s.status = selected.find(st => st === s.id) ? ActivityStatus.OK : ActivityStatus.KO;
			s.status = ActivityStatus.KO;
		});

		const newPrestazione: PrestazioneDTO = {
			id: props.row.id,
			name: props.row.name,
			operatore: props.row.operatore,
			codice: props.row.codice,
			cooperativa: props.row.cooperativa,
			origin: props.row.origin,
			type: props.row.type,
			startDate: props.row.startDate,
			endDate: props.row.endDate,
			status: ActivityStatus.KO,
			accesso: props.row.accesso,
			subTask: subTaskList,
			note: note,
			createdBy: props.row.createdBy,
			createdDate: props.row.createdDate,
			lastModifiedBy: props.row.lastModifiedBy,
			lastModifiedDate: props.row.lastModifiedDate,
			description: props.row.description,
			duration: seconds,
			idContatto: props.row.idContatto,
			notaStatus: noteStatus,
			boOpzionali: props.row.boOpzionali,
			boObbligatori: props.row.boObbligatori,
			tipoFrontOffice: props.row.tipoFrontOffice,
			puntoServizioId: props.row.puntoServizioId,
			puntoServizioName: props.row.puntoServizioName,
			paziente: props.row.paziente
		}

		onEsitoOk(newPrestazione);
	}

	const handlePausaClick = () => {
		stopTimer();
		const a = elapsedTime.split(':');

		const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
		let subTaskList = [...subTask];
		subTaskList.forEach(s => {
			s.status = selected.find(st => st === s.id) ? ActivityStatus.OK : ActivityStatus.KO;
		});

		const newPrestazione: PrestazioneDTO = {
			id: props.row.id,
			name: props.row.name,
			operatore: props.row.operatore,
			codice: props.row.codice,
			cooperativa: props.row.cooperativa,
			origin: props.row.origin,
			type: props.row.type,
			startDate: props.row.startDate,
			endDate: props.row.endDate,
			status: ActivityStatus.WAIT,
			accesso: props.row.accesso,
			subTask: subTaskList,
			note: note,
			createdBy: props.row.createdBy,
			createdDate: props.row.createdDate,
			lastModifiedBy: props.row.lastModifiedBy,
			lastModifiedDate: props.row.lastModifiedDate,
			description: props.row.description,
			duration: seconds,
			idContatto: props.row.idContatto,
			notaStatus: noteStatus,
			boOpzionali: props.row.boOpzionali,
			boObbligatori: props.row.boObbligatori,
			tipoFrontOffice: props.row.tipoFrontOffice,
			puntoServizioId: props.row.puntoServizioId,
			puntoServizioName: props.row.puntoServizioName,
			paziente: props.row.paziente
		}

		onEsitoOk(newPrestazione);
	}

	const onRowChange = (newSubTask: SubTaskDTO, index: number) => {
		let newSubTaskList = [...subTask];
		newSubTaskList[index] = newSubTask;
		setSubTask(newSubTaskList);
	}

	const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNote(event.target.value);
	}

	const handleNoteStatusChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setNoteStatus(event.target.value as string);
	};

	const onRowSelect = (subtask: SubTaskDTO) => {
		const selectedIndex = selected.indexOf(subtask.id);
		let newSelected: string[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, subtask.id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}

		setSelected(newSelected);
	};

	const isSelected = (subtask: SubTaskDTO) => {
		return selected.indexOf(subtask.id) !== -1
	}

	const handleModificaOperatore = (prestazione: PrestazioneDTO) => {
		onModificaOperatore && onModificaOperatore(prestazione);
	}

	const handleAbilitaAttivitaBo = (prestazioneBO: PrestazioneConfigDTO) => {
		if (prestazioneBO) {
			const prestazione = {
				id: prestazioneBO.id,
				name: prestazioneBO.name,
				codice: prestazioneBO.codice,
				description: prestazioneBO.description,
				type: prestazioneBO.type,
				idContatto: idContatto ? idContatto : '',
				origin: row.id,
				cooperativa: auth.state.cooperativa,
				puntoServizioId: auth.state.puntoServizioLogged?.id
			};

			auth.state.axiosInstance?.post('/api/prestazione/insert', prestazione)
				.then(res => {
					let newSelected: string[] = [];
					newSelected.push(prestazioneBO.id);
					setBackOfficeSelected(newSelected)
				})
				.catch(error => {
					toast.error('🛑 Errore durante l\'abilitazione della Prestazione BackOffice!');
					console.log(error);
				});
		}
	}

	return (
		<React.Fragment>
			<STableRow
				hover
				tabIndex={-1}
				key={row.id}
			>
				<STableCell style={{width: 150, borderBottom: 'none'}} component="th" id={labelid} padding="default">
					<IconButton className="color-primary" aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
						{open ? <IoIosArrowDropup size={20}/> : <IoIosArrowDropdown size={20}/>}
					</IconButton>
				</STableCell>
				{
					isBackoffice &&
					<STableCell style={{borderBottom: "none"}} padding="none">{dateTableFormat(row.startDate)}</STableCell>
				}
				<STableCell style={{borderBottom: "none"}} padding="default">{row.codice && row.codice !== '' ? row.codice : "-"}</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="none">{row.name}</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="default">{row.description && row.description !== '' ? row.description : "-"}</STableCell>
				{
					idContatto &&
					<STableCell style={{borderBottom: "none"}} padding="none">{row.paziente}</STableCell>
				}
				{
					(!idContatto && auth.state.roles && (auth.state.roles.indexOf(UserRole.SUPERVISOR) > -1
						|| auth.state.roles.indexOf(UserRole.RESPONSIBLE) > -1
						|| auth.state.roles.indexOf(UserRole.ADMIN) > -1)) &&
					<React.Fragment>
						<STableCell style={{borderBottom: "none", minWidth: "180px"}} padding="none">
							<div className="row align-items-center">
								<div className="col-8">
									{row.operatore}
								</div>
								<div className="col-4">
									<Tooltip title="Modifica Operatore">
										<IconButton className="right-icon-button" onClick={
											() => handleModificaOperatore(row)
										}>
											<FaUserEdit className="color-primary" size={15}></FaUserEdit>
										</IconButton>
									</Tooltip>
								</div>
							</div>
						</STableCell>
						<STableCell style={{borderBottom: "none"}} padding="default">{row.puntoServizioName}</STableCell>
					</React.Fragment>
				}
				<STableCell style={{borderBottom: "none"}} padding="default">
					<div className="d-flex align-items-center">
						<span>{(!terminated) ? elapsedTime : new Date(row.duration * 1000).toISOString().substr(11, 8)}</span>
						{(!terminated && row.operatore === auth.state.login && row.puntoServizioId === auth.state.puntoServizioLogged?.id) && (
							<IconButton
								onClick={handleStartStop}
								disabled={disabledTimer && !isRunning}
							>
								{isRunning ?
									<FaPauseCircle className="color-secondary" size={25}/>
									:
									<FaPlayCircle className={disabledTimer ? "color-secondary" : "color-green"} size={25}/>
								}
							</IconButton>
						)}
					</div>
				</STableCell>
			</STableRow>
			<TableRow className="bg-white">
				<TableCell style={{paddingBottom: 0, paddingTop: 0, paddingLeft: 100, paddingRight: 0}} colSpan={8}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box className="mt-3">
							<Table size="small" aria-label="purchases">
								<STableHeader
									numSelected={selected.length}
									onSelectAllClick={handleSelectAllClick}
									rowCount={row.subTask ? row.subTask.length : 0}
									headCells={rowHeadCells}
									addCheckbox={true}
									bgcolor="secondary"
									sortable={false}
									checkboxDisabled={terminated}
									disableAction={false}
								/>
								<TableBody>
									{subTask.map((subTaskRow, index) => {
											const isItemSelected = isSelected(subTaskRow);

											return (
												<SubTaskRow
													key={index}
													subTaskRow={subTaskRow}
													onRowChange={onRowChange}
													index={index}
													isItemSelected={isItemSelected}
													selected={selected}
													onRowSelect={onRowSelect}
													terminated={terminated}
													disabled={disabled}/>
											);
										}
									)}
								</TableBody>
							</Table>
							<Grid container spacing={0} className="w-100 my-3">
								<Grid item xs={8} className="pl-2"></Grid>
								<Grid item xs={4} className="pr-3">
									<FormControl variant="outlined" className="w-100">
										<SInputLabel id={"noteStatusLabel-" + row.id}>Note Esito</SInputLabel>
										<Select
											labelId={"noteStatus-" + row.id}
											id={"noteStatusSelect-" + row.id}
											label="Punto di Servizio"
											className="w-100 m-0"
											value={noteStatus}
											onChange={handleNoteStatusChange}
											disabled={terminated || disabled}
											MenuProps={{
												anchorOrigin: {
													vertical: "bottom",
													horizontal: "left"
												},
												transformOrigin: {
													vertical: "top",
													horizontal: "left"
												},
												getContentAnchorEl: null
											}}
										>
											<MenuItem value={"Nulla da segnalare"} key={"Nulla da segnalare"}>Nulla da segnalare</MenuItem>
											<MenuItem value={"Si sono verificate problematiche"} key={"Si sono verificate problematiche"}>Si sono verificate problematiche</MenuItem>
										</Select>
									</FormControl>
								</Grid>
							</Grid>

							<SSubtitle className="mt-3"><b>Prima di concludere l’attivit&agrave; puoi inserire una nota generica</b></SSubtitle>
							<Grid container spacing={0} className="w-100 mb-3">
								<Grid item xs={isBackoffice ? 6 : 8} className="pr-2">
									<TextField
										id={noteId}
										multiline
										rows={3}
										variant="outlined"
										className="w-100"
										value={note}
										onChange={handleTextChange}
										disabled={terminated || disabled}
										InputLabelProps={{shrink: true}}
									/>
								</Grid>
								{isBackoffice &&
								<Grid item xs={2} className="d-flex align-items-end">
									<SButton className="float-right" lowercase={true} wordspacing={false} disabled={terminated || disabled} onClick={handlePausaClick}>Salva per dopo</SButton>
								</Grid>
								}
								<Grid item xs={2} className="d-flex align-items-end">
									<SButton className="float-right" variant="verde" lowercase={true} wordspacing={false} disabled={terminated || disabled} onClick={handleEsitoOkClick}>Esito Ok</SButton>
								</Grid>
								<Grid item xs={2} className="d-flex align-items-end">
									<SButton className="float-right" variant="rosso" lowercase={true} onClick={handleEsitoKoClick} disabled={terminated || disabled} wordspacing={false}>Esito Ko</SButton>
								</Grid>
							</Grid>
							{backofficeOpzionali && backofficeOpzionali.length > 0 &&
							<React.Fragment>
								<SExtraBackOfficeLabel>Attivit&agrave; BackOffice opzionali</SExtraBackOfficeLabel>
								<List component="nav">
									{
										backofficeOpzionali.map((bo) => {
											return (
												<ListItem key={bo.id} hidden={backOfficeSelected.findIndex(b => b === bo.id) >= 0}>
													<Grid container spacing={0} className="w-100 d-flex align-items-center">
														<Grid item xs={4} className="pr-2">
															<p className="mb-0">{bo.name}</p>
														</Grid>
														<Grid item xs={2} className="pr-2">
															<SDialogButton
																onClick={() => {
																	handleAbilitaAttivitaBo(bo);
																}}>Abilita Attivit&agrave;</SDialogButton>
														</Grid>
													</Grid>
												</ListItem>
											)
										})
									}
									<Divider/>
								</List>
							</React.Fragment>
							}
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</React.Fragment>
	)
}
